import { usePushNotifications } from '@hooks/usePushNotifications';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';

export function MainLayout() {
	const { language } = useParams();
	const { i18n } = useTranslation();
	const { error } = usePushNotifications();

	useEffect(() => {
		if (language) {
			i18n.changeLanguage(language);
		}
	}, [language, i18n]);

	useEffect(() => {
		if (error) {
			console.error('Push notification initialization error:', error);
		}
	}, [error]);

	return (
		<>
			<Outlet />
		</>
	);
}
